// Core packages
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";

// Third party packages
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import {
  take
} from "rxjs/operators";

// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { AddCommunicationDialogComponent } from "src/app/shared/components/dialogs/add-communication-dialog/add-communication-dialog.component";
import { IUser } from "src/app/shared/models/user/user.interface";
import { ConfigService } from "src/app/shared/services/config.service";

/**
 * Script start
 */

@Component({
  selector: "qr-code-dialog",
  templateUrl: "./qr-code-dialog.component.html",
  styleUrls: ["./qr-code-dialog.component.scss"]
})
export class GenericDocsQrCodeDialogComponent
  implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  loggedUser: IUser;
  loggedUserPermissions: string[];
  lang = this.translateService.currentLang || this.translateService.defaultLang;
  dialogIsLoading = true; // Used to view/hide form loading spinner

  qrcodeData = "";
  print = false;
  isQrcode = true;

  /**
   * Class constructor
   */
  constructor(
    public dialogRef: MatDialogRef<GenericDocsQrCodeDialogComponent>,
    public cancelContractDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private configService: ConfigService,
    private translateService: TranslateService,
    private authService: AuthService,
    private cookieService: CookieService,
    private dialog: MatDialog,
    private toastrService: ToastrService,
  ) { }

  /**
   * Init components
   *
   * @since 1.0.0
   */
  ngOnInit(): void {
    // Get logged user data
    this.subscriptions.push(
      this.authService.loggedUser$.subscribe(res => (this.loggedUser = res))
    );
    this.subscriptions.push(
      this.authService.loggedUserPermissions$.subscribe(
        res => (this.loggedUserPermissions = res)
      )
    );

    // Get current lang
    this.lang =
      this.cookieService.get("lang") || this.configService.defaultLang;

    this.dialogIsLoading = false;

    if (this.data) {
      this.qrcodeData = `${this.configService.frontEndHost}/qrcode/${this.data.data._id}/genericDoc`;

      if (this.data.print) {
        this.print = true;
      }
    } else {
      this.isQrcode = false;
    }

  }

  /**
   * Handle component destroy
   *
   * @since 1.0.0
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Handle dialog closing
   *
   * @since 1.0.0
   */
  onClose(): void {
    this.dialogRef.close();
  }

  /**
   * Handle print QR-code
   *
   * @since 1.0.0
   */
  onPrint(): void {
    const printData = document.getElementById('dataToPrint').innerHTML//.cloneNode(true);

    // document.body.appendChild(printData);
    // window.print();
    // document.body.removeChild(printData);
    const openWindow = window.open("", "title", "attributes");
    openWindow.document.write(printData);
    openWindow.document.close();
    openWindow.focus();
    openWindow.print();
    openWindow.close();
  }
  
  /**
   * Handle Qrcode send by email
   */
  onSendQrcodeByEmail(): void {
    const qrImage = document
      .getElementById("idQrcodeDataImage")
      .lastElementChild.lastElementChild.getAttribute("src");

    // Open dialog
    const newDialogRef = this.dialog.open(
      AddCommunicationDialogComponent,
      {
        minWidth: "60%",
        maxHeight: "98vh",
        data: {
          qrImage,
          // phonebook: this.company.get("phonebook"),
        },
        disableClose: true,
      }
    );

    // Subscribe to dialog result (only for 1 emit thanks to "take()")
    newDialogRef
      .beforeClosed()
      .pipe(take(1))
      .subscribe((res) => {
        if (!res) {
          return;
        }
        this.toastrService.success(
          this.translateService.instant("communications.add.sendedSuccessfully")
        );
      });
  }

}